import { render, staticRenderFns } from "./CreateStockistPackage.vue?vue&type=template&id=3e165285&scoped=true"
import script from "./CreateStockistPackage.vue?vue&type=script&lang=js"
export * from "./CreateStockistPackage.vue?vue&type=script&lang=js"
import style0 from "./CreateStockistPackage.vue?vue&type=style&index=0&id=3e165285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e165285",
  null
  
)

export default component.exports